import React from 'react';
import InboxTable from '../components/InboxTable';

const fmtDate = (d) =>
  d ? new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '—';

const COLUMNS = [
  { key: 'NAME',       label: 'Name' },
  { key: 'EMAIL',      label: 'Email' },
  { key: 'MOBILENO',   label: 'Mobile' },
  { key: 'MESSAGE',    label: 'Message', render: (v) => v?.length > 60 ? v.slice(0, 60) + '…' : v },
  { key: 'ENTRY_TIME', label: 'Date', render: fmtDate },
];

const DETAIL_FIELDS = [
  { label: 'Name',      key: 'NAME' },
  { label: 'Email',     key: 'EMAIL' },
  { label: 'Mobile',    key: 'MOBILENO' },
  { label: 'Address',   key: 'ADDRESS' },
  { label: 'Message',   key: 'MESSAGE' },
  { label: 'Received',  key: 'ENTRY_TIME', render: fmtDate },
];

const Enquiries = () => (
  <InboxTable
    title="Contact Enquiries"
    subtitle="Messages submitted via the contact form"
    apiPath="/api/admin/enquiries"
    columns={COLUMNS}
    detailFields={DETAIL_FIELDS}
    searchPlaceholder="Search by name, email or mobile..."
  />
);

export default Enquiries;
